export interface ContractorHostBridge {
  readonly capability?: string;
}

declare global {
  interface Window {
    __AUTOCONTROL_CONTRACTOR__?: ContractorHostBridge;
  }
}

let memorySecret: string | null = null;

/**
 * Capability is held in memory only.
 * Delivery channels (priority):
 * 1) explicit bootstrap argument / host bridge
 * 2) URL fragment `#c=<secret>` from CheckTS invite email (fragment not sent to servers)
 * Query-string tokens are intentionally ignored (would leak via logs/Referer).
 */
export function bootstrapContractorCapability(secret?: string): void {
  const fromHost = secret ?? window.__AUTOCONTROL_CONTRACTOR__?.capability;
  if (fromHost !== undefined && fromHost.trim() !== '') {
    memorySecret = fromHost.trim();
    return;
  }
  const fromFragment = readCapabilityFromFragment();
  if (fromFragment !== null) {
    memorySecret = fromFragment;
    clearCapabilityFragment();
    return;
  }
  memorySecret = null;
}

export function readContractorCapability(): string | null {
  return memorySecret;
}

export function setContractorCapability(secret: string): void {
  memorySecret = secret.trim() === '' ? null : secret.trim();
}

function readCapabilityFromFragment(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  if (hash === '') {
    return null;
  }
  const params = new URLSearchParams(hash);
  const value = params.get('c');
  if (value === null || value.trim() === '') {
    return null;
  }
  return value.trim();
}

function clearCapabilityFragment(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const path = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState({}, '', path);
}
